import { Link } from 'react-router-dom';

const areas = [
  {
    name: 'Beylikdüzü',
    desc: 'Tüm mahalle ve semtlerde 7/24 çilingir hizmeti',
    neighborhoods: ['Adnan Kahveci', 'Barış', 'Büyükşehir', 'Cumhuriyet', 'Dereağzı', 'Gürpınar', 'Kavaklı', 'Marmara'],
    img: 'https://readdy.ai/api/search-image?query=Beylikduzu%20Istanbul%20modern%20residential%20neighborhood%20aerial%20view%2C%20apartment%20buildings%2C%20urban%20district%2C%20Turkey%2C%20daytime%20clear%20sky&width=600&height=400&seq=area001&orientation=landscape',
    color: 'from-orange-600 to-orange-800',
  },
  {
    name: 'Esenyurt',
    desc: 'Esenyurt mahallelerinde hızlı çilingir desteği',
    neighborhoods: ['Akevler', 'Ardıçlı', 'Fatih', 'Güzelyurt', 'Mehterçeşme', 'Pınar', 'Saadetdere', 'Yeşilkent'],
    img: 'https://readdy.ai/api/search-image?query=Esenyurt%20Istanbul%20dense%20urban%20residential%20area%2C%20high%20rise%20apartment%20buildings%2C%20busy%20district%2C%20Turkey%2C%20aerial%20photography&width=600&height=400&seq=area002&orientation=landscape',
    color: 'from-stone-700 to-stone-900',
  },
  {
    name: 'Büyükçekmece',
    desc: 'Büyükçekmece semtlerinde güvenilir çilingir',
    neighborhoods: ['Alkent', 'Gürpınar', 'Kumburgaz', 'Mimaroba', 'Pınartepe', 'Tepecik', 'Atatürk', 'Fatih'],
    img: 'https://readdy.ai/api/search-image?query=Buyukcekmece%20Istanbul%20coastal%20district%2C%20lake%20view%2C%20residential%20buildings%2C%20Turkey%2C%20scenic%20urban%20landscape&width=600&height=400&seq=area003&orientation=landscape',
    color: 'from-amber-700 to-amber-900',
  },
  {
    name: 'Bahçeşehir',
    desc: 'Bahçeşehir ve çevresinde profesyonel çilingir',
    neighborhoods: ['1. Kısım', '2. Kısım', '3. Kısım', 'Gölet', 'Şelale', 'Çınar', 'Bahçeşehir Merkez'],
    img: 'https://readdy.ai/api/search-image?query=Bahcesehir%20Istanbul%20planned%20residential%20community%2C%20modern%20houses%2C%20green%20areas%2C%20suburban%20district%2C%20Turkey&width=600&height=400&seq=area004&orientation=landscape',
    color: 'from-red-700 to-red-900',
  },
];

export default function AreasPreview() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <span className="inline-flex items-center gap-2 text-orange-500 text-xs font-bold uppercase tracking-widest mb-3">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>
              Hizmet Bölgelerimiz
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
              İstanbul Avrupa Yakası'nda<br />7/24 Çilingir Hizmeti
            </h2>
          </div>
          <Link
            to="/hizmet-bolgeleri"
            className="inline-flex items-center gap-2 text-orange-500 font-semibold text-sm whitespace-nowrap cursor-pointer hover:underline"
          >
            Tüm Bölgeleri Gör
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {areas.map((area) => (
            <Link
              key={area.name}
              to="/hizmet-bolgeleri"
              className="group relative rounded-2xl overflow-hidden cursor-pointer block"
            >
              <div className="w-full h-56">
                <img
                  src={area.img}
                  alt={`${area.name} Çilingir`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className={`absolute inset-0 bg-gradient-to-t ${area.color} opacity-70 group-hover:opacity-80 transition-opacity duration-300`}></div>
              <div className="absolute inset-0 p-5 flex flex-col justify-end">
                <h3 className="text-white font-extrabold text-xl mb-1">{area.name}</h3>
                <p className="text-white/80 text-xs mb-3">{area.desc}</p>
                <div className="flex flex-wrap gap-1">
                  {area.neighborhoods.slice(0, 4).map((n) => (
                    <span key={n} className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full">{n}</span>
                  ))}
                  {area.neighborhoods.length > 4 && (
                    <span className="bg-white/20 text-white text-xs px-2 py-0.5 rounded-full">+{area.neighborhoods.length - 4}</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
